angular.module('BBPublicBooking')
    .controller('Total', ($scope, $rootScope, QueryStringService, LoadingService, BBModel, BBWidget) => {

    'ngInject';

    $rootScope.$on('booking:moved', (event, total) => {
        if (total) {
            total.bookingHasBeenMoved = true;
            $scope.total = total;
        }
    });

    const loader = LoadingService.$loader($scope);

    $rootScope.connection_started
        .then(() => {

            // When moving a booking we may already have the total before instantiating the bbTotal controller
            // in this case we should not attempt to fetch the purchase total again.
            if (BBWidget.preventPurchaseTotalRequest) {
                return;
            }

            $scope.bb.payment_status = null;

            let id;

            // Obtain proper purchase id from URL if we were redirected from payment page.
            if (QueryStringService('purchase_id')) {
                id = QueryStringService('purchase_id');
            } else if (QueryStringService('id')) {
                id = QueryStringService('id');
            }

            if (id && !$scope.bb.total) {
                loader.notLoaded();

                BBModel.PurchaseTotal
                    .$query({
                        url_root: $scope.bb.api_url,
                        purchase_id: id
                    })
                    .then((total) => {
                        $scope.total = total;
                        loader.setLoaded();

                        // Emit checkout:success event if the amount paid matches the total price.
                        if (total.paid === total.total_price) {
                            return $scope.$emit('checkout:success', total);
                        }
                    });
            } else {
                $scope.total = $scope.bb.total;

                // In case total price is zero, don't try to emit checkout event. It should be done before by
                // bb-checkout directive during the checkout step.
                if ($scope.total.total_price !== 0) {
                    // Emit checkout:success event if the amount paid matches the total price.
                    if ($scope.total.paid === $scope.total.total_price) {
                        $scope.$emit('checkout:success', $scope.total);
                    }
                }
            }

            // Reset ready for another booking.
            return $scope.reset();
        })
        .catch((error) => {
            loader.setLoadedAndShowError(error, 'Sorry, something went wrong');
        });

});



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/total/bb_total.controller.js